export const reviewsTranslations = {
    en: {
        title: "Guest reviews",
        reviews: [
            {
                text: "An absolute must if you have a little desire for adventure. It was one of the most beautiful days in and around Slano. crew incl. Entertainment was just great, thank you for this great day",
                author: "Kathrin"
            },
            {
                text: "Excellent day with a smiling and warm team. Perfect welcome. Thank you Rebecca💕. top crew. Thanks boys. Perfect day program with visit to the typical islands. We bring your smiles back to France. Nathalie and Corinne (alcohol & no alcohol🍻👍)",
                author: "Nathalie"
            },
            {
                text: "Petar and Vice are deadly duo! Great trip, I'll be back soon. Highly recommended!!",
                author: "Marko"
            },
            {
                text: "A great trip with lovely people. Well worth the money, highly recommended",
                author: "Henderson"
            }
        ]
    },
    hr: {
        title: "Recenzije gostiju",
        reviews: [
            {
                text: "Apsolutni must ako imate malo žeđi za avanturom. Bio je to jedan od najljepših dana u Slanom i okolici. Posada uključujući zabavu bila je jednostavno odlična, hvala vam na ovom prekrasnom danu.",
                author: "Kathrin"
            },
            {
                text: "Odličan dan s nasmijanim i toplim timom. Savršen doček. Hvala Rebecca💕. Vrhunska posada. Hvala momci. Savršen dnevni program s posjetom tipičnim otocima. Vaše osmijehe nosimo natrag u Francusku.",
                author: "Nathalie"
            },
            {
                text: "Petar i Vice su smrtonosni duo! Odlično putovanje, uskoro se vraćam. Topla preporuka!!",
                author: "Marko"
            },
            {
                text: "Odlično putovanje s divnim ljudima. Vrijedilo je svake kune, toplo preporučujem.",
                author: "Henderson"
            }
        ]
    },
    es: {
        title: "Reseñas de huéspedes",
        reviews: [
            {
                text: "Imprescindible si tienes un poco de deseo de aventura. Fue uno de los días más hermosos en Slano y sus alrededores. La tripulación incluida la animación fue simplemente genial, gracias por este gran día.",
                author: "Kathrin"
            },
            {
                text: "Excelente día con un equipo sonriente y cálido. Bienvenida perfecta. Gracias Rebecca💕. Tripulación de primera. Gracias chicos. Programa diario perfecto con visita a las islas típicas. Llevamos vuestras sonrisas de vuelta a Francia.",
                author: "Nathalie"
            },
            {
                text: "¡Petar y Vice son un dúo increíble! Gran viaje, volveré pronto. ¡Muy recomendable!!",
                author: "Marko"
            },
            {
                text: "Un gran viaje con gente encantadora. Vale cada céntimo, muy recomendable.",
                author: "Henderson"
            }
        ]
    },
    it: {
        title: "Recensioni degli ospiti",
        reviews: [
            {
                text: "Assolutamente da fare se hai un po' di voglia di avventura. È stata una delle giornate più belle a Slano e dintorni. L'equipaggio incluso l'intrattenimento era semplicemente fantastico, grazie per questa splendida giornata.",
                author: "Kathrin"
            },
            {
                text: "Giornata eccellente con un team sorridente e caloroso. Accoglienza perfetta. Grazie Rebecca💕. Equipaggio top. Grazie ragazzi. Programma giornaliero perfetto con visita alle isole tipiche. Portiamo i vostri sorrisi in Francia.",
                author: "Nathalie"
            },
            {
                text: "Petar e Vice sono un duo formidabile! Ottimo viaggio, tornerò presto. Altamente consigliato!!",
                author: "Marko"
            },
            {
                text: "Un ottimo viaggio con persone meravigliose. Vale ogni centesimo, altamente consigliato.",
                author: "Henderson"
            }
        ]
    },
    pl: {
        title: "Opinie gości",
        reviews: [
            {
                text: "Absolutny must jeśli masz trochę chęci na przygodę. To był jeden z najpiękniejszych dni w Slano i okolicach. Załoga łącznie z rozrywką była po prostu świetna, dziękujemy za ten wspaniały dzień.",
                author: "Kathrin"
            },
            {
                text: "Doskonały dzień z uśmiechniętym i ciepłym zespołem. Idealne powitanie. Dziękuję Rebecca💕. Świetna załoga. Dzięki chłopaki. Idealny program dnia z wizytą na typowych wyspach. Zabieramy wasze uśmiechy z powrotem do Francji.",
                author: "Nathalie"
            },
            {
                text: "Petar i Vice to śmiertelny duet! Świetna wycieczka, wracam wkrótce. Gorąco polecam!!",
                author: "Marko"
            },
            {
                text: "Świetna wycieczka z uroczymi ludźmi. Warta każdego grosza, gorąco polecam.",
                author: "Henderson"
            }
        ]
    },
    fr: {
        title: "Avis des clients",
        reviews: [
            {
                text: "Un incontournable si vous avez un peu l'âme aventurière. Ce fut l'une des plus belles journées à Slano et ses environs. L'équipage et les animations étaient tout simplement formidables, merci pour cette merveilleuse journée.",
                author: "Kathrin"
            },
            {
                text: "Excellente journée avec une équipe souriante et chaleureuse. Accueil parfait. Merci Rebecca💕. Super équipage. Merci les gars. Programme journalier parfait avec visite des îles typiques. Nous ramenons vos sourires en France. Nathalie et Corinne (alcool & sans alcool🍻👍)",
                author: "Nathalie"
            },
            {
                text: "Petar et Vice sont un duo redoutable ! Super voyage, je reviendrai bientôt. Hautement recommandé!!",
                author: "Marko"
            },
            {
                text: "Un super voyage avec des gens adorables. Vraiment worth it, hautement recommandé.",
                author: "Henderson"
            }
        ]
    },
    de: {
        title: "Gästebewertungen",
        reviews: [
            {
                text: "Ein absolutes Muss, wenn man ein bisschen Abenteuerlust hat. Es war einer der schönsten Tage in und um Slano. Die Crew inklusive Unterhaltung war einfach großartig, vielen Dank für diesen tollen Tag.",
                author: "Kathrin"
            },
            {
                text: "Toller Tag mit einem lächelnden und herzlichen Team. Perfekter Empfang. Danke Rebecca💕. Top Crew. Danke Jungs. Perfektes Tagesprogramm mit Besuch der typischen Inseln. Wir nehmen eure Lächeln mit zurück nach Frankreich.",
                author: "Nathalie"
            },
            {
                text: "Petar und Vice sind ein tödliches Duo! Tolle Tour, ich komme bald wieder. Sehr empfehlenswert!!",
                author: "Marko"
            },
            {
                text: "Eine tolle Tour mit wunderbaren Menschen. Jeden Cent wert, sehr empfehlenswert.",
                author: "Henderson"
            }
        ]
    }
};